import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchingTradeDataAction, updateTradeDataAction } from '../actions';
import api from '../../lib/api';

function* fetchTradeDataSaga() {
  try {
      console.log('Fetching trading data from API');
      const data = yield call(api.getTradingData);
      yield put(updateTradeDataAction(data || []));
    
  } catch (error) {
    console.error('Error fetching trading data:', error);
  }
}

export function* watchFetchTradeData() {
  yield takeLatest(fetchingTradeDataAction, fetchTradeDataSaga);
}
